export default {
    "all-classes": "جميع الصفوف",
    "class": "الصف",
    "all-students": "كل الشعب",
    "for-all-students": "لكل الطلاب",
    "group-messages-sent": "الرسائل الجماعية المرسلة",
    "wait-a-little": "انتظر قليلا",
    "no-messages": "لا توجد رسائل",
    "for-the-whole-school": "لكل المدرسة",
    "to": "إلى",
    "students": "الطلاب"
}